<bn-loading-overlay></bn-loading-overlay>

<h5>Arquivos enviados (lotes)</h5>

<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="row align-items-center">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button
          class="btn btn-primary"
          type="button"
          placement="bottom"
          ngbTooltip="Selecione esta opção para enviar um arquivo contendo os leilões realizados"
          [routerLink]="['/leilao/cadastro/lote']"
          [disabled]="!podeEnviarArquivo">
          <i class="fa fa-upload"></i>
          Enviar arquivo de leilões realizados
        </button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success" (click)="buscarProtocolosLeiloesEnviados(false)"
          >Pesquisar</button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <ng-select
          *ngIf="podeEscolherAgente"
          [items]="agentesFinanceiros"
          bindLabel="nome"
          bindValue="id"
          placeholder="Todos"
          formControlName="agenteFinanceiro">
        </ng-select>
        <input
          *ngIf="!podeEscolherAgente"
          type="text"
          class="form-control"
          disabled
          [value]="agenteFinanceiroLogado?.nome"
        >
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="statusProtocolo">Status do arquivo: </label>
        <select id="statusProtocolo" class="form-select" formControlName="statusProtocolo">
          <option [selected]="true">Todos</option>
          <option *ngFor="let status of valoresStatusProtocolo">{{ status.label }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="idSolicitacaoApiExt">Id Solicitação API Externa:</label>
        <input type="text" bnMask="INTEIRO" class="form-control" name="idSolicitacaoApiExt" formControlName="idSolicitacaoApiExt">
      </div>
    </div>
    <div class="row">
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioInicial">Data de envio inicial:</label>
        <bn-datepicker name="dataEnvioInicial" idInput="dataEnvioInicial" formControlName="dataEnvioInicial">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioFinal">Data de envio final:</label>
        <bn-datepicker name="dataEnvioFinal" idInput="dataEnvioFinal" formControlName="dataEnvioFinal">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="modoEnvio">Modo de envio:</label>
        <select id="modoEnvio" class="form-select" formControlName="modoEnvio">
          <option [selected]="true">Todos</option>
          <option>Efetivo</option>
          <option>Apenas validação</option>
        </select>
      </div>
    </div>
  </form>
</div>

<app-leilao-listagem *ngIf="protocolos"
  [protocolos]="protocolos"
  [atributosPaginacao]="atributosPaginacao"
  [cnpjAgente]="cnpjUsuario"
  (aoMudarPagina)="mudancaPagina($event)"
>
</app-leilao-listagem>
